<template>
    <div class="bannerContainer">
        <img src="../../assets/imgs/contact/bbg.png" id="bannerBg">
    </div>
</template>

<script>
export default {
    name: 'Screen1',
}
</script>

<style scoped>
    .bannerContainer{
        padding-top: 50px;
        background: #121927;
        height: 335px;
        display: flex;                     
        align-items:Center;  
    }
    #bannerBg{
        margin: 0 auto;
        width: 885px;
        display: block;
    }
</style>
